import { createSelector } from '@reduxjs/toolkit';

export const selectUsersState = (state) => state.users;

export const selectUsers = (state) => state.users.users;

export const selectCurrentUser = (state) => state.users.currentUser;

export const selectSelectedUserDetail = (state) => state.users.selectedUserDetail;

export const selectLoading = (state) => state.users.loading;

export const selectDetailLoading = (state) => state.users.detailLoading;

export const selectError = (state) => state.users.error;

export const selectPagination = (state) => state.users.pagination;

export const selectStatistics = (state) => state.users.statistics;

// Đếm thật từ BE (GET /api/users/statistics), KHÔNG tính từ danh sách đã phân trang.
// Vai trò là RBAC động: card "Quản trị viên" lấy byRole["ADMIN"].
export const selectUserStatistics = createSelector(
    [selectStatistics],
    (statistics) => ({
        total: statistics?.total ?? 0,
        active: statistics?.active ?? 0,
        inactive: statistics?.inactive ?? 0,
        admins: statistics?.byRole?.['ADMIN'] ?? 0
    })
);

export const selectUsersByRole = createSelector(
    [selectUsers, (state, role) => role],
    (users, role) => users.filter(user => user.role === role)
);

export const selectActiveUsers = createSelector(
    [selectUsers],
    (users) => users.filter(user => user.active !== false)
);

export const selectInactiveUsers = createSelector(
    [selectUsers],
    (users) => users.filter(user => user.active === false)
);

export const selectFormattedUsers = createSelector(
    [selectUsers],
    (users) => users.map(user => ({
        ...user,
        statusText: user.active !== false ? 'Hoạt động' : 'Đã khóa',
        statusColor: user.active !== false ? 'text-green-600' : 'text-red-600',
        lastLoginFormatted: user.lastLogin ?
            new Date(user.lastLogin).toLocaleString('vi-VN') :
            'Chưa đăng nhập'
    }))
);
